(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/components/correction-mail.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/components/correction-mail.js');
'use strict';

const {
  Fieldset,
  Checkbox
} = svs.ui.reactForm;
const {
  TopHeader
} = svs.myProfile.react.shared.components;
const {
  backendName,
  checkboxNotifcation,
  titles,
  icons
} = svs.myProfile.constants;

const MAIL = [backendName.WIN_RESULTS];

const MAIL_YES = {
  [backendName.WIN_RESULTS]: true
};

const MAIL_NO = {
  [backendName.WIN_RESULTS]: false
};

const CorrectionMail = _ref => {
  let {
    children,
    model,
    handleCheckbox
  } = _ref;
  let isCheckedMail = false;

  MAIL.forEach(id => {
    if (model[id]) {
      isCheckedMail = true;
    }
  });
  return React.createElement("div", null, React.createElement(TopHeader, {
    icon: icons.CORRECT,
    title: titles.CORRECT
  }), React.createElement("p", null, "Vi kan skicka vinnarmeddelande n\xE4r du vinner och p\xE5minnelser om du spelar flerveckorsspel. G\xE4ller inte f\xF6r Oddset och \xE4r en spelpaus aktiv skickas ingen kommunikation ut."), React.createElement(Fieldset, {
    legend: titles.CORRECT,
    srOnly: true
  }, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(Checkbox, {
    checked: isCheckedMail,
    id: "gameNotification",
    onChange: () => {
      handleCheckbox(isCheckedMail ? MAIL_NO : MAIL_YES, isCheckedMail, checkboxNotifcation.TRACK_MAIL);
    }
  }, "Skicka e-post efter avgjort spel om du vunnit.")), children));
};
svs.myProfile.react.pages.notifications.components.CorrectionMail = CorrectionMail;

 })(window);